module.exports = __webpack_public_path__ + "img/maison19.749d17ca.jpg";